import React, { useEffect } from 'react'
import styles from "./RegistrationForm.module.css"
import { ButtonCustom } from '../BootstrapComponents/ButtonCustom'
import { useState } from 'react'
import { BreathAPIs } from '../APIs/BreathAPIs'

import { connect } from 'react-redux'
import { setAlert } from '../Actions/Alert'

import PropTypes from 'prop-types'
import { Link, Navigate } from 'react-router-dom'
import BreatheEV_Logo from '../Images/logo.png';
import { Image } from 'react-bootstrap'
import Alert from '../BootstrapComponents/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt } from '@fortawesome/free-solid-svg-icons'
import { logout } from '../Actions/Auth';
import store from '../store';
import { loadUser } from '../Actions/Auth';
import { Button } from 'antd';
import LegalDoc from './LegalDoc';
import { IoCheckbox } from 'react-icons/io5'
import { MdOutlineQrCodeScanner } from 'react-icons/md'
import PhoneVerificationModal from './PhoneVerificationModal'
import PhoneInput from '../components/PhoneInput'
import QRCodeScanner from '../components/QRCodeScanner'
import { extractLocationCodeFromScan } from '../Utils/locationCode'


const LocationSelectionForm = (props) => {

  const [location, setLocation] = useState([]);
  const [phone, setPhone] = useState('');
  const [receive_sms_updates, setReceiveSMSUpdates] = useState(false);
  const [fetchedLocations, setFetchedLocations] = useState([]);
  const [legalDoc, setLegalDoc] = useState(false);
  const [legalDocVisible, setLegalDocVisible] = useState(false);
  const [legalDocType, setLegalDocType] = useState('');

  const [isPhoneNumberVerified, setIsPhoneNumberVerified] = useState(null);
  const [receive_promotional_messages, setReceivePromotionalMessages] = useState(false);
  const [isCheckingPhone, setIsCheckingPhone] = useState(false);
  

  const [locationCode, setLocationCode] = useState('');
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [isCheckingLocationCode, setIsCheckingLocationCode] = useState(false);
  const [isRedirectingToThirdParty, setIsRedirectingToThirdParty] = useState(false);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [company, setCompany] = useState('');

  // load the companies offered by the entered location code
  useEffect(() => {
    if (!/^[A-Z]{6}$/.test(locationCode)) {
      setCompanyOptions([]);
      setCompany('');
      return;
    }
    let cancelled = false;
    BreathAPIs.checkLocationCode(locationCode)
      .then((res) => {
        if (cancelled) return;
        const companies = [...new Set((res?.data || []).flatMap((loc) => loc.companies || []))];
        setCompanyOptions(companies);
        setCompany((prev) => companies.includes(prev) ? prev : '');
      })
      .catch(() => {
        if (cancelled) return;
        setCompanyOptions([]);
        setCompany('');
      });
    return () => { cancelled = true; };
  }, [locationCode]);

  const checkLocationCodeAndRedirectIfNeeded = async (code) => {
    setIsCheckingLocationCode(true);
    try {
      const selLocation = await BreathAPIs.checkLocationCode(code, { includeRedirectCode: true });
      const fetchedLocation = selLocation?.data?.[0];

      if (fetchedLocation?.enableThirdPartyRedirect && fetchedLocation?.thirdPartyRedirectUrl && fetchedLocation?.redirectCodeId === code) {
        setIsRedirectingToThirdParty(true);
        setTimeout(() => {
          window.location.href = fetchedLocation.thirdPartyRedirectUrl;
        }, 2000);
        return;
      }

      setIsCheckingLocationCode(false);
    } catch (error) {
      console.error('Error fetching location code:', error);
      setIsCheckingLocationCode(false);
    }
  };

  // useEffect(() => {
  //   fetchLocations();
  // }, [])
  // const fetchLocations = async () => {
  //   try {
  //     const res = await BreathAPIs.getLocations();
  //     setFetchedLocations(res.data);
  //   } catch (error) {
  //     console.log(error)
  //   }

  // }
  const handleQRScan = (scannedText) => {
    const code = extractLocationCodeFromScan(scannedText);
    if (!/^[A-Z]{6}$/.test(code)) {
      return false;
    }
    setLocationCode(code);
    setShowQRScanner(false);
    checkLocationCodeAndRedirectIfNeeded(code);
    return true;
  };

  const sanitizePhoneNumber = (input) => {
    const sanitized = input.replace(/\D/g, '');
    return sanitized.startsWith('1') ? sanitized.slice(1) : sanitized;
};
  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!legalDoc) {
        props.setAlert('Please accept privacy policy.', 'danger');
      }
      else if ((!/^\d+$/.test(phone) || (phone.length !== 10))) {
        props.setAlert("Must enter a valid phone number to receive SMS", 'warning');
      }
      else if(!isPhoneNumberVerified){
        setAlert("Please verify your phone number.", 'danger')
      }
      else if (locationCode !== null && locationCode !== "" && !/^[A-Z]{6}$/.test(locationCode)) {
        props.setAlert("Invalid Location code. Please enter 6 uppercase letters.", 'danger');
      }
      else if (companyOptions.length > 0 && !company) {
        props.setAlert("Please select your company.", 'danger');
      }
      else {
        try {
          let firstLocation = [];

          if (locationCode !== "") {
            const selLocation = await BreathAPIs.checkLocationCode(locationCode);

            if (selLocation?.data?.length) {
              firstLocation = selLocation.data[0];
            } else {
              props.setAlert("Code is not valid", 'danger');
              return;
            }
          } else {
            setLocation([]);
          }

          const userProfile = {
            showLocationSelector: false,
            location: firstLocation._id || [],
            company: (locationCode !== "" && companyOptions.includes(company)) ? company : null,
            phone,
            isPhoneVerified : isPhoneNumberVerified,
            receive_sms_updates,
            receive_promotional_messages
          };

          const res = await BreathAPIs.updateProfile(userProfile);

          if (res?.data?.success) {
            props.setAlert(res.data.message, 'success');
            store.dispatch(loadUser());
          } else {
            props.setAlert(res?.data?.message || "Error updating profile", 'danger');
          }

        } catch (error) {
          const errorMessage = error.response?.data?.error?.msg || "Code is not valid";
          props.setAlert(errorMessage, 'danger');
        }

      }
    } catch (err) {
      props.setAlert('Error creating user.', 'danger');
    }
  };


  const [showPhoneVerificationModal, setShowPhoneVerificationModal] = useState(false);
  const handleCheckboxChange = async () => {
    setIsCheckingPhone(true);
    try {
      let isPhoneUnique = await BreathAPIs.checkIfPhoneUniqueForRegistration(phone)
      console.log("isPhoneUnique", isPhoneUnique)
      if (phone && !isPhoneUnique.data.ok) {
        props.setAlert("Phone already exists", "danger")
        setReceiveSMSUpdates(false);
        setIsPhoneNumberVerified(false);
      }
      else if (!/^\d+$/.test(phone) || !(phone.length === 10)) {
        props.setAlert("Please enter a valid phone number", 'warning');
        setReceiveSMSUpdates(false);
        setIsPhoneNumberVerified(false);
      } else {
        setShowPhoneVerificationModal(true);
        setReceiveSMSUpdates(false);
        setIsPhoneNumberVerified(false);
      }
    } finally {
      setIsCheckingPhone(false);
    }
  };

  const handleVerificationSuccess = () => {
    setReceiveSMSUpdates(true);
    setIsPhoneNumberVerified(true);
  };





  if (props.loading || props.userType == null) {
    if (props.isAuthenticated === false) {
      return (<Navigate to="/login" />)
    }
    return (<div className={'spinner'}><FontAwesomeIcon icon={faBolt} size="3x" /></div>);
  }

  if (isCheckingLocationCode) {
    return (
      <section className="bg-light py-3 py-md-5 py-xl-8 min-vh-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
              <div className="mb-5">
                <div className="text-center mb-4">
                  <Image className={styles['logo']} src={BreatheEV_Logo} alt="" />
                </div>
              </div>
              <div className="card border border-light-subtle rounded-4">
                <div className={`card-body p-3 p-md-4 p-xl-5 text-center ${styles['loader-body']}`}>
                  <div className={`spinner-border ${styles['loader-spinner']}`} role="status">
                    <span className="visually-hidden">{isRedirectingToThirdParty ? 'Redirecting...' : 'Checking location code...'}</span>
                  </div>
                  <p className={styles['loader-text']}>{isRedirectingToThirdParty ? 'Redirecting...' : 'Checking location code...'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return props.isAuthenticated ? (
    <section className="bg-light py-3 py-md-5 py-xl-8 min-vh-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
            <div className="mb-5">
              <div className="text-center mb-4">
                <Image className={styles['logo']} src={BreatheEV_Logo} alt="" />
              </div>
            </div>

            {props.showLocationSelector ? <><div className="card border border-light-subtle rounded-4">
              <div className="card-body p-3 p-md-4 p-xl-5">
                <form onSubmit={onSubmit}>
                  {/* <h5 className={`mb-4 ${styles['login-title']}`}>Select an location</h5> */}
                  <Alert></Alert>
                  <div className="row gy-3 overflow-hidden">
                    <div className="col-12">
                      <div className="form-floating mb-3">
                        {/* <select
                          class
                          Name="form-select"
                          id="location"
                          name="location"
                          onChange={(e) => setLocation(e.target.value)}
                        >
                          <option value=""  >Select an location</option>
                          {fetchedLocations.map((apt) => (
                            <option key={apt._id} value={apt._id}>
                              {apt.locationName}
                            </option>
                          ))}
                        </select> */}
                        <input id='locationCode' className={`form-control ${styles['form-control-qr']}`} type="text" name="locationCode" placeholder='Location Code' onChange={(e) => { setLocationCode(e.target.value); }} value={locationCode} />
                        <button
                          type="button"
                          className={styles['qr-scan-icon']}
                          onClick={() => setShowQRScanner(true)}
                          aria-label="Scan location QR code"
                        >
                          <MdOutlineQrCodeScanner />
                        </button>
                        <label htmlFor="locationCode" className="form-label">Location Code (<i>Optional</i> )</label>
                      </div>
                      <QRCodeScanner
                        open={showQRScanner}
                        onClose={() => setShowQRScanner(false)}
                        onScan={handleQRScan}
                        title="Scan Location QR Code"
                      />
                    </div>

                    {companyOptions.length > 0 && (
                      <div className="col-12">
                        <div className="form-floating mb-3">
                          <select id="company" className="form-select" name="company" value={company} onChange={(e) => setCompany(e.target.value)}>
                            <option value="" disabled>Select your company</option>
                            {companyOptions.map((c) => <option key={c} value={c}>{c}</option>)}
                          </select>
                          <label htmlFor="company" className="form-label">Company</label>
                        </div>
                      </div>
                    )}


                    <div className="col-12">
                      <div className={`form-floating mb-3 ${styles['input-left-box']}`}>
                        {isPhoneNumberVerified ? <div className="form-control">{'+1' + phone}</div> : <PhoneInput addCode={true} className="form-control" type="text" name="phone" placeholder='Phone' onChange={(e) => { setPhone(sanitizePhoneNumber(e.target.value)); }} value={phone} required/>}
                        <span className={styles['left-box-component']}>+1</span>
                        <label htmlFor="phone" className="form-label">Phone</label>
                      </div>

                      {showPhoneVerificationModal && (
                        <PhoneVerificationModal
                          closeModal={() => setShowPhoneVerificationModal(false)}
                          onVerificationSuccess={handleVerificationSuccess}
                          modalVisible={showPhoneVerificationModal}
                          phoneNumber={phone}
                        />
                      )}

                    </div>

                    <div className="col-12">
                      {!isPhoneNumberVerified ? <label className={styles['sms-checkbox']}>
                        {!isCheckingPhone && <input checked={receive_sms_updates} className="form-check-input" type={'checkbox'} onChange={handleCheckboxChange} disabled={isCheckingPhone} />}
                        {isCheckingPhone
                          ? <><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Please verify your phone number to complete registration.</>
                          : 'Please verify your phone number to complete registration.'
                        }
                      </label>
                        :
                        <label className={styles['sms-checkbox']}>
                          <IoCheckbox /> Phone number ({'+1' + phone}) verified. Expect charging session updates via SMS.
                        </label>}
                    </div>

                    {/* {isPhoneNumberVerified && 
                      <div className="col-12">
                        <label className={styles['sms-checkbox']}>
                          <input
                            checked={receive_sms_updates}
                            className="form-check-input"
                            type="checkbox"
                            onChange={(e) => setReceiveSMSUpdates(e.target.checked)}
                          />
                          Get real-time charging alerts and helpful reminders so you never miss a charge. Msg frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help, or manage in profile.
                        </label> 
                      </div>
                    } */}

                  {
                      <div className="col-12">
                        <label className={styles['sms-checkbox']}>
                          <input
                            checked={receive_promotional_messages}
                            className="form-check-input"
                            type="checkbox"
                            onChange={(e) => setReceivePromotionalMessages(e.target.checked)}
                          />
                          Get BreatheEV offers & updates by SMS. Msg & data rates may apply. Reply STOP to opt out. Consent not required.
                        </label>
                      </div>
                    }

                    <div className="col-12">
                      <label className={styles['privacy-policy-check-box']}>
                        <input className="form-check-input" type={'checkbox'} onChange={() => setLegalDoc(!legalDoc)} />
                        I accept the
                        <button onClick={() => { setLegalDocType('terms-of-service'); setLegalDocVisible(true); }} type="button">Terms of Use</button>
                        and have read the
                        <button onClick={() => { setLegalDocType('privacy-policy'); setLegalDocVisible(true); }} type="button">Privacy Notice</button>
                      </label>
                      <LegalDoc type={legalDocType} modalVisible={legalDocVisible} closeModal={() => { setLegalDocVisible(false); }} />
                    </div>

                    <div className="col-12">
                      <div className="d-grid">
                        <ButtonCustom
                          variant={"primary"}
                          text={"Register"}
                          onClick={onSubmit}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              
            </div>
            <div className="d-flex gap-2 gap-md-4 flex-column flex-md-row justify-content-md-center align-items-center mt-4">
            <Link className="link-secondary text-decoration-none" onClick={props.logout} to={`${process.env.REACT_APP_BASE_URL}/login`}>Back to Login</Link>
          </div>
          </>
              :
              <div className="card border border-light-subtle rounded-4">
                <div className="card-body p-3 p-md-4 p-xl-5">
                  <h5 className={`mb-4 ${styles['login-title']}`}>User Successfully Registered!</h5>
                  {/* <Alert></Alert> */}
                  <div className="row gy-3 overflow-hidden">
                    <div className="col-12">
                      <div className="d-grid">
                        <Link
                          variant="primary"
                          to={'/'}
                          className='btn btn-primary'
                          text={""}>Go to Home Page</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

            
          </div>
        </div>
      </div>
    </section>
  ) : (
    <Navigate to="/login" />
  );

}



LocationSelectionForm.propTypes = {
  isAuthenticated: PropTypes.bool,
  loading: PropTypes.bool,
  userType: PropTypes.string,
  setAlert: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  showLocationSelector: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading,
  userType: state.auth && state.auth.user ? state.auth.user.type : null,
  location: state.auth && state.auth.user ? state.auth.user.location : null,
  showLocationSelector: state.auth && state.auth.user ? state.auth.user.showLocationSelector : false,
});

export default connect(mapStateToProps, { setAlert, logout })(LocationSelectionForm);